export class Civilite {
    constructor(
        public cCivilite?: string,
        public lCivilite?: string,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/civilite.model.ts